import { TranslocoService } from '@ngneat/transloco';
import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

@Component({
  selector: 'kt-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  lang$: Observable<string>;

  constructor(private transloco: TranslocoService) {}

  ngOnInit() {
    this.lang$ = this.transloco.langChanges$;
  }
}
